<template>
  <v-card flat class="container--fluid">
    <v-card flat class="container--fluid bg-gray no-margins elevation-1 not-rounded">
      <v-card flat class="v-card__container">
    
        <h4>E-bok - teori och praktiska moment</h4>
      </v-card>
    </v-card>
    <v-row class="mt-2 d-flex align-center">
      <v-col cols="6">
        <v-card-text>
          <v-select
            data-cy="select-course-profession"
            v-model="profession"
            :items="professions"
            item-text="name"
            item-value="id"
            outlined
            label="Välj yrke"
            @change="fetchCourses"
            return-object
          />
        </v-card-text>

        <v-card-text v-if="practicalCourses.length">
          <ProfessionReformSelector class="mb-4" @on-change="fetchCourses(profession, $event)" />
          
          <h6 class="mt-4 mb-2">Distansutbildningsgivare: {{ profession.distanceEducationProvider.name }}</h6>

          <v-select
            data-cy="select-course-name"
            v-model="professionCourse"
            :items="practicalCourses"
            item-text="courseName"
            item-value="id"
            outlined
            label="Välj kurs"
            return-object
          >
            <template v-slot:item="data">
              <v-list-item-content>
                <v-list-item-title>{{ data.item.courseName }}</v-list-item-title>
                <v-list-item-subtitle>{{ data.item.groupName }}</v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-select>
        </v-card-text>
      </v-col>
      <v-col cols="6" class="mt-n8">
        <v-card-text>
          <v-btn
            @click="showVisualization = true"
            :disabled="!(profession && profession.distanceEducationProvider && profession && profession.distanceEducationProvider.id === 1)"
            v-if="practicalCourses.length"
          >
            <v-icon>$sl-view-on</v-icon>Visualisera
          </v-btn>
        </v-card-text>
      </v-col>
    </v-row>
    <v-card-text v-if="profession && profession.distanceEducationProvider && professionCourse">
      <ProviderBook
        v-bind:profession="profession"
        v-bind:professionCourse="professionCourse" 
        v-bind:hasCourses="get(profession, 'distanceEducationProvider.features.hasCourses',false)"
      />
    </v-card-text>
    <v-dialog v-model="showVisualization" max-width="600px">
      <ProviderBookVisualized v-if="showVisualization" 
        :profession="profession"
        :practicalCourses="practicalCourses"
        @close="showVisualization = false"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import API from '@/services/api.js'
import { mapGetters } from 'vuex'
import ProviderBook from '@/components/admin/book/ProviderBook'
import ProviderBookVisualized from '@/components/admin/book/ProviderBookVisualized'
import filter from 'lodash/filter'
import sortBy from 'lodash/sortBy'
import get from 'lodash/get'
import ProfessionReformSelector from '@/components/admin/profession/ProfessionReformSelector.vue'

// @group Ebook
// BookElements component
export default {
  name: 'BookElements',

  components: {
    ProviderBook,
    ProviderBookVisualized,
    ProfessionReformSelector
  },

  data: () => ({
    profession: null,
    professionCourse: null,
    professions: [],
    theoreticalCourses: [],
    practicalCourses: [],
    distanceEducationProviders: [],
    showVisualization: false,
  }),

  watch: {
    profession() {
      this.professionCourse=null
    }
  },

  computed: {
    ...mapGetters('basic', ['basicProfessions', 'getProfessionById'])
  },
    /**
     * @vuese
     * Used to list distance education providers
     */
  created() {
    this.professions = filter(this.basicProfessions, ['isApplicationProfession', true])

    API.listDistanceEducationProviders()
    .then(res=>{
      this.distanceEducationProviders = res.data
    })
    .catch(error=>{
      console.log(error)
    })
  },

  methods: {
     /**
     * @vuese
     * Used to  fetch profession courses
     * @arg the argument is an integer represent course id
     */
    fetchCourses(obj, reform = null) {
      if (! obj) return
      this.professionCourse = null

      API.listPlainProfessionCourses(obj.id, { data: { reform: get(reform, 'text', 'Gy11') }})
      .then(res=>{
        this.practicalCourses = sortBy(res.data, ['groupName', 'courseName'] )
      })
      .catch(error=>{
        console.log(error)
      })
    },

    get: get
  }
}
</script>

<style lang="sass" scoped>

</style>